import { PnlBreakdown } from "reports/getters/pnlBreakdownGetter/pnlBreakdownTypes";
import { useParams } from "react-router";
import { SummaryMetricInput } from "reports/utils/metricUtils";
import { useGetShifts } from "reports/utils/shiftsHook";
import CardWrapper from "../../CardWrapperStyles";
import {
  useGeAndLtFromUrl,
  useProcessGroupNameAndMachemetryIds,
} from "../../reportUtils";
import MetricAndPnLBreakdown from "./MetricAndPnLBreakdown";
import { BreakdownTypeEnum } from "./metricAndPnlBreakdownTypes";
import { MachineBreakdownsStyles } from "./MetricAndPnLBreakdowns";
import { getPnlTimes } from "../PnLChart/pnlChartUtils";
import useEosData from "reports/store/useEosData";
import { ReportParams } from "reports/types";

export function ShiftPnlBreakdowns({
  summaryMetricsInputList,
  getCustomSummaryMetricsInputListWithPnlBreakdown,
  customHeader,
  showReportLink = false,
  shiftNamesToExclude,
  shiftData,
}: {
  summaryMetricsInputList: SummaryMetricInput[];
  getCustomSummaryMetricsInputListWithPnlBreakdown?: (
    pnlBreakdown: PnlBreakdown
  ) => SummaryMetricInput[];
  customHeader?: string;
  showReportLink?: boolean;
  shiftNamesToExclude?: string[];
  shiftData?: PnlBreakdown[];
}) {
  const { pnlBreakdownsByShift } = useEosData();
  const { ckey: tenant, processGroupName } = useParams() as ReportParams;
  const range = useGeAndLtFromUrl();
  const { machemetryIds } = useProcessGroupNameAndMachemetryIds({
    defaultProcessGroupName: processGroupName,
  });

  const shifts = useGetShifts(range, machemetryIds[0]).map(
    ({ range, shift }) => {
      return { ge: range.ge, lt: range.lt, shiftName: shift.name };
    }
  );

  const header = customHeader ? customHeader : "Shift Breakdown";
  const data = shiftData ?? pnlBreakdownsByShift;

  return (
    <CardWrapper>
      <div className="header">{header}</div>
      <div className="subHeader">Click on any shifts to see more details</div>
      <MachineBreakdownsStyles>
        {data
          .filter(
            ({ shiftName }) =>
              !shiftNamesToExclude ||
              !shiftName ||
              !shiftNamesToExclude.includes(shiftName)
          )
          .map((pnlBreakdown, index) => {
            const pnlTimes = getPnlTimes({ data: pnlBreakdown });

            const shift = shifts.filter(({ shiftName }) => {
              return pnlBreakdown.shiftName == shiftName;
            })[0];

            return (
              <MetricAndPnLBreakdown
                key={pnlBreakdown.shiftName}
                pnlBreakdown={pnlBreakdown}
                processName={pnlBreakdown?.shiftName ?? ""}
                skuData={[]}
                pnlTimes={pnlTimes}
                maxBreakdownHeaderLength={10}
                showMetricTitle={index === 0}
                summaryMetricsInputList={summaryMetricsInputList}
                getCustomSummaryMetricsInputListWithPnlBreakdown={
                  getCustomSummaryMetricsInputListWithPnlBreakdown
                }
                breakdownType={BreakdownTypeEnum.shift}
                reportLink={
                  showReportLink
                    ? `${window.location.protocol}//${
                        window.location.host
                      }/${tenant}/reports/eos/${
                        processGroupName || "all"
                      }?ge=${shift?.ge}&lt=${shift?.lt}`
                    : undefined
                }
                processId=""
              />
            );
          })}
      </MachineBreakdownsStyles>
    </CardWrapper>
  );
}
